import { useTranslation } from '@dreamstack/i18n'
import type { FunctionComponent } from 'react'
import { HeadingH2 } from '../layout/Texts'

interface PropertyVirtualRoundtripProps {
  floorfyLink?: {
    url: string
  }
}

export const PropertyVirtualRoundtrip: FunctionComponent<
  PropertyVirtualRoundtripProps
> = ({ floorfyLink }) => {
  const t = useTranslation()

  if (!floorfyLink) return null

  return (
    <div className="w-full col-span-full">
      <HeadingH2 className="col-span-12 mt-px-48 md:mt-px-96 lg:col-start-2 lg:col-span-10">
        {t('accentro:floorfy')}
      </HeadingH2>
      <div
        className="col-span-12 mt-px-16 md:mt-px-80"
        style={{ aspectRatio: '16/9' }}
      >
        <iframe
          title="Floorfy Viewer"
          width="100%"
          height="100%"
          src={`${floorfyLink.url}?play=yes`}
          allowFullScreen
          allow="autoplay"
        />
      </div>
    </div>
  )
}
